import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useRef, useState} from 'react';
import {Button, Form} from "react-bootstrap";
import axios from "axios";

export const LabRecordPrintView = forwardRef((props: { entityQr: string, uhid: string, id: string, printHeader: boolean, stateTracker: any, referringDr?: any }, ref) => {

    const [record, setRecord] = useState<any>();
    const [entityDetails, setEntityDetails] = useState<any>();
    const [patientDetails, setPatientDetails] = useState<any>();
    const [collectionDate, setCollectionDate] = useState<string>();
    const [reportDate, setReportDate] = useState<string>();
    const [borderClass, setBorderClass] = useState<string>("border");
    const [topMargin, setTopMargin] = useState(40)
    const [bottomMargin, setBottomMargin] = useState(40)


    useEffect(() => {
        if (props.id) {
            fetchRecord()
        }
    }, [props.id, props.stateTracker])

    useEffect(() => {
        if (props.printHeader) {
            setBorderClass("")
        }
    }, [props.printHeader])

    useEffect(() => {
        if (props.entityQr) {
            fetchEntityDetails()
            if(props.entityQr == "qme-330") {
                setTopMargin(170)
                setBottomMargin(80)
            }
        }
    }, [props.entityQr])

    useEffect(() => {
        if (props.uhid != null) {
            axios.get('/api/backend/customers/fetch/' + props.uhid)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setPatientDetails(resp.data)
                })
                .catch(err => {
                    console.error(err);
                    if (err.response && err.response!.status && err.response!.status === 403) {
                        handleLogout()
                    }
                })
        }
    }, [props.uhid])

    function fetchRecord() {
        axios.get('/api/backend/customer/records/fetch/id/' + props.id)
            .then(resp => {
                resp.data.data = JSON.parse(resp.data.data)
                setRecord(resp.data)
                setCollectionDate(new Date(resp.data.createdAt).toDateString())
                setReportDate(new Date(resp.data.updatedAt).toDateString())
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                ;
            });
    }


    function fetchEntityDetails() {
        axios.get('/api/backend/entity/profile/' + props.entityQr)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setEntityDetails(resp.data);
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }

    function outsideRange(value: any, rangeStart: any, rangeEnd: any): boolean {
        if (!isNaN(rangeStart) && !isNaN(rangeEnd) && !isNaN(value)) {
            return !(Number.parseFloat(value) >= Number.parseFloat(rangeStart) && Number.parseFloat(value) <= Number.parseFloat(rangeEnd));
        } else {
            return false
        }
    }


    return (
        <>
            {record && <div className="row printView">
                <div className="col col-12 my-2">
                    <div className={borderClass}>
                        <div className="px-5 py-3">
                            {props.printHeader && <>
                                {props.entityQr != "qme-330" && <>
                                    <div className="font-weight-bold fs-4 text-center">
                                        {entityDetails && entityDetails.businessName}
                                    </div>
                                    <div className="font-weight-bold fs-7 text-center">
                                        {entityDetails && entityDetails.businessAddress}
                                    </div>
                                </>
                                }
                                <div className="card my-2">
                                    <div className="row mx-2 my-2">
                                        <div className="col col-6">
                                            <table>
                                                {patientDetails && <tr>
                                                    <td className="text-secondary">Name</td>
                                                    <td>:&nbsp;&nbsp;{patientDetails.name}</td>
                                                </tr>}
                                                {patientDetails && <tr>
                                                    <td className="text-secondary">Mobile</td>
                                                    <div
                                                        className="d-inline-block">:&nbsp;&nbsp;{patientDetails.mobile}</div>
                                                </tr>}
                                                {patientDetails && patientDetails.age &&
                                                    <tr>
                                                        <td className="text-secondary">Age</td>
                                                        <td>:&nbsp;&nbsp;{patientDetails.age}&nbsp;years</td>
                                                    </tr>}
                                                {patientDetails && patientDetails.gender &&
                                                    <tr>
                                                        <td className="text-secondary">Gender</td>
                                                        <td>:&nbsp;&nbsp;{patientDetails.gender}</td>
                                                    </tr>}
                                                {patientDetails && <tr>
                                                    <td className="text-secondary">UHID</td>
                                                    <td>:&nbsp;&nbsp;{patientDetails.uhid}</td>
                                                </tr>}
                                            </table>
                                        </div>
                                        <div className="col col-6">
                                            <table>
                                                <tr>
                                                    <td className="text-secondary">Sample Date</td>
                                                    <td>:&nbsp;&nbsp;{new Date(collectionDate).toLocaleDateString("en-GB")}</td>
                                                </tr>
                                                {reportDate && <tr>
                                                    <td className="text-secondary">Report Date</td>
                                                    <td>:&nbsp;&nbsp;{new Date(reportDate).toLocaleDateString("en-GB")}</td>
                                                </tr>}
                                                {props.referringDr && <tr>
                                                    <td className="text-secondary">Referring Dr</td>
                                                    <td>:&nbsp;&nbsp;{props.referringDr}</td>
                                                </tr>}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </>}
                            <div className="my-4">
                                <div className="text-decoration-underline mb-2">{record.data.category}</div>
                                <div>
                                    <table className="table table-borderless">
                                        <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Result</th>
                                            <th>Unit</th>
                                            <th>Bio-reference range</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {record.data.parameters && record.data.parameters.map((p, index) => {
                                            if (p.result) {
                                                return <tr key={"para" + index}>
                                                    <td>{p.name}</td>
                                                    <td className={outsideRange(p.result, p.rangeStart, p.rangeEnd) ? "fw-bold" : ""}>{p.result}</td>
                                                    <td>{p.units}</td>
                                                    <td>{p.bioReference}</td>
                                                </tr>
                                            }
                                        })

                                        }
                                        </tbody>
                                    </table>
                                    {record.data.notes && <div className="my-2 border border-1 border-dark pl-2">
                                        <b>Notes:</b>
                                        <div className="pl-2" dangerouslySetInnerHTML={{__html: record.data.notes}}/>
                                    </div>}
                                    {record.data.comments && <div className="my-2 border border-1 border-dark pl-2">
                                        <b>Comments:</b>
                                        <div className="pl-2" dangerouslySetInnerHTML={{__html: record.data.comments}}/>
                                    </div>}
                                </div>
                            </div>

                            {entityDetails && entityDetails.labIncharge &&
                                <div className="mt-5 fw-bold">Lab incharge : <span
                                    className="fw-normal">{entityDetails.labIncharge}</span></div>
                            }
                        </div>
                    </div>
                </div>
            </div>}
            <style jsx>{`@page {
              margin: ${topMargin}px 0px ${bottomMargin}px 0px !important;
            }`}</style>
        </>
    );
});

LabRecordPrintView.displayName = "LabRecordPrintView";